//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headers from '../../components/headers'

export default {
    components: {
        headers,
    },
    data () {
        return {
             model:{},
             bannerModel:[],
             ArtModel:[],
        }
    },
     created(){
        this.getIndexBanner();//轮播图
        this.getPageUrlList()//视频
    },
    methods: {
        getIndexBanner(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getIndexBanner?type=5',this.model,{emulateJSON:true}).then(function(res){
              
                    if(res.body.success)
                    {
                      this.bannerModel= res.body.data
                    }    
                },function(res){
            });
        },
        getPageUrlList(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mindex/getPageUrlList?pageId=5&devPageAreaId=6',this.model,{emulateJSON:true}).then(function(res){
              console.log(res)
                    if(res.body.success)
                    {
                      this.ArtModel= res.body.data
                    }    
                },function(res){
            });
        },
       goUrl(Url){
              if(this.isLogin()==false){
                    alert("请先登录")
                    this.$router.push({path:'/auth/login'})
                }else{
                   window.location.href = Url
                }
            
        },
        open(url){
            this.$router.push(url)
        },
        openUrl(url){
          if(url==null||url==""){
            return;
          }
          window.location.href=url;
        },
    }
}



// WEBPACK FOOTER //
// ./src/views/service/serviceIndex.vue